import { DriveEta, Pool, Spa } from '@material-ui/icons';

import { ROUTE_PATH as EFS_PARKING_PATH } from '@/features/efsParkingPage/consts';
import { ROUTE_PATH as EFS_USERS_PATH } from '@/features/efsUsersPage/consts';
import { ROUTE_PATH as EFS_VISIT_RECORDS_PATH } from '@/features/efsVisitRecordsPage/consts';

export const efsSalesMenu = [
  {
    label: 'Пользователи EFS',
    path: EFS_USERS_PATH,
    Icon: Spa,
  },
  {
    label: 'Паркинг',
    path: EFS_PARKING_PATH,
    Icon: DriveEta,
  },
  {
    label: 'EFS',
    Icon: Pool,
    path: EFS_VISIT_RECORDS_PATH,
  },
];
